import { UserProfileChangePasswordForm, UserProfileEditForm, UserProfileNotificationSettingsForm } from "../organism"

type UserProfileDetailTemplateProps = {
  selectedSection: string
}

export const UserProfileDetailTemplate = ({ selectedSection }: UserProfileDetailTemplateProps) => {
  return (
    <>
      {
        (
          () => {
            switch(selectedSection) {
              case '1':
                return <UserProfileEditForm />
              
              case '2':
                return <UserProfileChangePasswordForm />

              case '3':
                return <UserProfileNotificationSettingsForm />

              default:
                console.warn('invalid option')
            }
          }
        )()
      }
    </>
  )
}